var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text-xs my-2 text-gray-700"},[_vm._v(_vm._s(_vm.documentName))]),_c('el-progress',{attrs:{"text-inside":true,"stroke-width":26,"percentage":_vm.percentage,"status":_vm.status}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }